import { useMachines } from "./use-machines";

export const useUpstreamMachines = (refetchInterval: number | false) => {
	return useMachines({
		refetchInterval: refetchInterval,
		machineTypes: ["CVPRange", "Em", "Fusion", "X4", "X5", "X5wPrint", "X6", "X7", "ZebraPrinter"],
	});
};
